import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Container, useMantineTheme } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import type { Event } from "event/types/event.model";
import { useEvent } from "event/hooks/useEvent";
import { useGetCrossbarEventQuery } from "crossbar/api/crossbar-event.api";
import { useGetCrossbarQuery } from "crossbar/api/crossbar.api";
import { PlayLoader } from "quiz/play/components/PlayLoader";
import { CrossbarView } from "./CrossbarView";

export function CrossbarPresenter() {
  const event: Event | undefined = useEvent();
  const { crossbarEventId } = useParams<{
    eventId: string;
    crossbarEventId: string;
  }>();

  const { data: crossbarEvent, isSuccess: isSuccessCrossbarEvent } =
    useGetCrossbarEventQuery(crossbarEventId as string);

  const crossbarId = useMemo(() => crossbarEvent?.crossbar_id, [crossbarEvent]);

  const { data: crossbar, isSuccess: isSuccessCrossbar } = useGetCrossbarQuery(
    crossbarId!,
    { skip: !crossbarId },
  );

  const theme = useMantineTheme();

  const styles = useCallback(() => {
    // const backgroundImage = event
    // ? event.images?.eventDesktopBackground
    // : crossbar?.images.background;
    const backgroundImage = crossbar
      ? crossbar.images.background
      : event?.images.eventDesktopBackground;

    return {
      desktopBackground: {
        backgroundImage: `url(${backgroundImage}`,
        backgroundSize: "auto",
        backgroundPosition: "",
        backgroundRepeat: "no-repeat",
      },
      mobileBackground: {
        backgroundImage: `url(${backgroundImage}`,
        backgroundSize: "auto",
        backgroundPosition: "",
        backgroundRepeat: "no-repeat",
        maxWidth: 768,
      },
    };
  }, [crossbar, event]);

  const { width } = useViewportSize();
  const isMobile = width <= 768;
  const currentStyle = isMobile
    ? styles().mobileBackground
    : styles().desktopBackground;

  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100dvh",
        maxWidth: "none",
        textAlign: "center",
        fontFamily: theme.fontFamily,
        ...currentStyle,
      }}
    >
      {isSuccessCrossbar &&
      isSuccessCrossbarEvent &&
      crossbar &&
      crossbarEvent ? (
        <CrossbarView crossbar={crossbar} crossbarEvent={crossbarEvent} />
      ) : (
        <PlayLoader message="" />
      )}
    </Container>
  );
}
